<script>
    import SmartFilterObject from '@/components/page-smart-filter/SmartFilterObject.vue';

    export default {
        computed: {
            smartFilter() {return this.$store.getters.IMAGE_SMART_FILTERS},
        },
        components: {
            SmartFilterObject: SmartFilterObject,
        }
    }
</script>


<template>
    <div class="right_header">
        <label>Smart Filter:</label>
    </div>
    <ul class="clear_ul">
        <SmartFilterObject 
            v-for="(smartFilterValue, smartFilterIndex) in smartFilter" :key="smartFilterIndex"
            :smartFilter="smartFilterValue"
        />
    </ul>
</template>